<template>
  <div class="box-container flex-column justify-center cover">
    <DemandeConnexion
      :affiche="showDialog"
      :texte="avertissement"
      :isConnexionLara="isConnexionLara"
      @close="closeDialog"
    ></DemandeConnexion>
    <div class="d-flex flex-row justify-center" style="max-width: 80%">
      <v-card elevation="7" outlined shaped class="p-2 px-sm-4 py-sm-4">
        <v-card-title>Assistance à la connexion</v-card-title>
        <ol class="ml-4">
          <li class="py-2">
            <p class="description my-0">
              J'ai un dossier avec l'Ordre et je suis
              <strong
                >membre, bénéficiaire de droits acquis, candidat à l'admission,
                ou j'ai déjà suivi une formation sur cette plateforme.</strong
              >
            </p>
            <p class="my-0 ml-6">
              Cliquez sur <strong>« Se connecter »</strong>. Ensuite, entrez le
              courriel de correspondance que vous avez fourni à l'Ordre et s'il
              s'agit de votre première connexion à la nouvelle plateforme de
              l'Ordre, cliquez "Première connexion" et suivez les
              instructions pour obtenir votre mot de passe par courriel. S'il ne
              s'agit pas de votre première connexion entrez votre mot de passe.
            </p>
          </li>
          <li class="py-2">
            <p class="description my-0">
              Je n'ai pas de dossier avec l'Ordre, je dois créer un compte,
              cliquez sur Créer un compte.
            </p>
          </li>
        </ol>
        <div class="text-center my-6">
          <v-btn x-large class="mx-3" color="primary" :href="url_extranet"
            >Se connecter</v-btn
          >
          <v-btn
            x-large
            style="background-color: red"
            class="mx-3 light-blue-button"
            color="primary"
            @click="openDialog()"
            >Créer un compte</v-btn
          >
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
  import DemandeConnexion from "../components/common/DemandeConnexion";
	import { getExtranetUrl } from "@/utils/stringUtils"

export default {
  components: {
    DemandeConnexion,
  },
  data: function () {
    return {
			url_extranet: getExtranetUrl(process.env.VUE_APP_CONNEXION_EXTERNE_XTRANET),
      avertissement:
        "Si vous êtes <strong>membre de l'Ordre, bénéficiaire de droits acquis, candidat à l'admission</strong> ou avez déjà participé à une formation sur cette plateforme, vous avez un compte. Fermez cette fenêtre et utilisez le bouton <strong>SE CONNECTER</strong> pour atteindre la plateforme.<br><br><strong>Si toutefois vous n'avez jamais effectué de transaction avec l'Ordre,</strong> cliquez « poursuivre » pour créer un compte.",
      showDialog: false,
      isConnexionLara: true,
    };
  },
  mounted() {
    try {
      if (this.$route.query.returnUrl != null) {
        console.log("Return url", this.$route.query.returnUrl);
        localStorage.setItem("laraReturnUrl", this.$route.query.returnUrl);
      } else {
        localStorage.setItem("laraReturnUrl", "");
      }
    } catch (erreur) {
      console.log(erreur);
    }
  },
  methods: {
    closeDialog() {
      this.showDialog = false;
    },
    openDialog() {
      this.showDialog = true;
    },
  },
};
</script>

<style scoped lang="scss">
.cover {
  background-image: url("../assets/cover.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
ul {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
}
li {
  border: 1px solid #ccc;
  margin-bottom: 8px;
  border-radius: 8px;
  margin-right: 8px;
  padding: 0 10px;
}
</style>